/** Handle one layer of meeting UI before Android backgrounds the app. */
export function handleMeetingBack(doc: Document = document): 'handled' | 'meeting' | 'none' {
  const visible = (el: HTMLElement | null) => !!el && getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden' && el.getClientRects().length > 0;
  const dialogs: Array<[string, string]> = [
    ['security-overview-modal', 'btn-close-security-overview'],
    ['create-poll-modal', 'btn-cancel-create-poll'],
    ['device-settings-modal', 'btn-close-device-settings'],
    ['rename-modal', 'btn-cancel-rename'],
    ['screen-picker-modal', 'btn-cancel-picker'],
    ['confirm-leave-modal', 'btn-cancel-leave-modal'],
    ['version-info-modal', 'btn-close-version-info'],
    ['recording-options-modal', 'btn-close-rec-options'],
    ['recording-success-modal', 'btn-close-rec-success'],
    ['mobile-more-sheet-overlay', 'btn-close-more-sheet'],
  ];
  for (const [layerId, closeId] of dialogs) {
    if (!visible(doc.getElementById(layerId))) continue;
    doc.getElementById(closeId)?.click();
    return 'handled';
  }
  // Do not background a meeting while an unrecognised dialog is open.
  if (Array.from(doc.querySelectorAll<HTMLElement>('.picker-modal-overlay, .rename-modal-overlay, [role="dialog"]')).some(visible)) return 'handled';
  if (visible(doc.getElementById('side-panel'))) {
    doc.getElementById('btn-close-panel')?.click();
    return 'handled';
  }
  for (const id of ['more-options-popover', 'view-mode-popover', 'screen-share-active-menu', 'quick-audio-menu', 'quick-camera-menu']) {
    const menu = doc.getElementById(id);
    if (visible(menu)) { doc.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true })); menu!.style.display = 'none'; return 'handled'; }
  }
  return visible(doc.querySelector<HTMLElement>('.conference-screen')) ? 'meeting' : 'none';
}
